// import './bootstrap';
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import { createInertiaApp } from '@inertiajs/react';
import posthog from 'posthog-js';
import { createRoot } from 'react-dom/client';
import 'vite/modulepreload-polyfill';
import AppLayout from './Pages/App/Layout';
import './otel';
import '../css/app.css';
const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, { api_host: posthogHost });
}

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob('./Pages/**/*.tsx');
    const page = pages[`./Pages/${name}.tsx`];

    if (typeof page === 'undefined') {
      return;
    }

    const _page = await page();
    _page.default.layout =
      _page.default.layout || ((page) => <AppLayout>{page}</AppLayout>);

    return _page;
  },
  setup({ el, App, props }) {
    const root = createRoot(el);

    root.render(<App {...props} />);
  },
});
